import { GET_FEEDS, CREATE_FEED } from './actions';
import { SET_FEEDS, SET_FEEDS_FILTER_QUERY, SET_FEEDS_FILTER_TYPE, SET_FEEDS_FILTER_STATUS } from './mutations';
import HTTP from './../lib/HTTP';

const state = {
  data: null,
  query: "",
  selectedType: "All",
  selectedStatus: "All",
};

const mutations = {
  [SET_FEEDS](_state, feeds) {
    _state.data = feeds;
  },
  [SET_FEEDS_FILTER_QUERY](_state, query){
    _state.query = query;
  },
  [SET_FEEDS_FILTER_TYPE](_state, type){
    _state.selectedType = type;
  },
  [SET_FEEDS_FILTER_STATUS](_state, status){
    _state.selectedStatus = status;
  }
};

const actions = {
  [GET_FEEDS](context) {
    return new Promise((resolve, reject) => {
      HTTP.get('feeds').then((res) => {
        console.log(res);
        if (res && res.data && res.data.content) {
          context.commit(SET_FEEDS, res.data.content);
        }
        resolve(res);
      }).catch((err) => {
        console.log(err);
        reject(err);
      });
    });
  },
  [CREATE_FEED](context, data) {
    return new Promise((resolve, reject) => {
      HTTP.post('feeds', data, {
        headers : { 'content-type': 'multipart/form-data' }
      }).then((res) => {
        console.log(res);
        resolve(res);
      }).catch((err) => {
        console.log(err);
        reject(err);
      });
    });
  }
};

export default {
  state,
  mutations,
  actions,
};
